import { Dialog } from '@headlessui/react';
import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  isOpen: boolean;
  toggleOpen: () => void;
}

const Modal: React.FC<Props> = ({ isOpen, toggleOpen, children }) => {
  if (!isOpen) {
    return children;
  }

  return (
    <Dialog open={isOpen} onClose={toggleOpen} className="relative z-50">
      <div className="fixed inset-0 flex justify-center items-center bg-black/20">
        <Dialog.Panel className="max-w-4xl ">{children}</Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default Modal;
